import { useState } from "react";
import { CameraScanButton } from "@/components/scan/CameraScanButton";
import { Ticket, X } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useOnline } from "@/lib/connectivity";
import { formatMoney } from "@/lib/money";

export function CreditNoteBox({ total, applied, onApply, dp, currency }) {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const online = useOnline();
  const apply = async (e) => {
    e?.preventDefault();
    if (!code.trim()) return;
    setBusy(true);
    setError("");
    try {
      const { data } = await api.get(`/credit-notes/${encodeURIComponent(code.trim())}/check`, { params: { total } });
      onApply(data);
      setCode("");
    } catch (ex) {
      setError(errMsg(ex));
    } finally {
      setBusy(false);
    }
  };
  if (applied)
    return (
      <div className="flex items-center gap-2 rounded-xl border border-emerald-300 bg-emerald-50 px-3 py-2.5 text-sm" data-testid="payment-cn-applied">
        <Ticket className="h-4 w-4 text-emerald-700" />
        <span className="font-mono font-bold">{applied.number}</span>
        <span className="ml-auto font-mono font-bold text-emerald-800">−{currency} {formatMoney(applied.amount, dp)}</span>
        <button onClick={() => onApply(null)} className="grid h-7 w-7 place-items-center rounded-lg hover:bg-emerald-100" aria-label="Remove credit note" data-testid="payment-cn-remove"><X className="h-4 w-4" /></button>
      </div>
    );
  return (
    <form onSubmit={apply} className="space-y-1.5">
      <div className="flex gap-2">
        <input value={code} onChange={(e) => setCode(e.target.value)} disabled={!online} placeholder={online ? "Credit note — scan or type CN-…" : "Credit note needs internet"}
          className="h-11 flex-1 rounded-xl border border-slate-200 px-3 font-mono text-sm uppercase outline-none focus:border-slate-900 disabled:bg-slate-100" data-testid="payment-cn-input" />
        <CameraScanButton disabled={!online} title="Scan credit note" testid="payment-cn-camera-button" className="h-11 w-11"
          onDetect={(c) => { setCode(c.toUpperCase()); return { ok: true, label: c.toUpperCase() }; }} />
        <button disabled={!online || busy} className="h-11 rounded-xl border-2 border-slate-900 px-4 text-sm font-bold disabled:opacity-40" data-testid="payment-cn-apply">Apply</button>
      </div>
      {!online && <div className="text-xs font-semibold text-amber-700" data-testid="payment-cn-offline">Needs internet</div>}
      {error && <div className="text-xs font-semibold text-rose-600" data-testid="payment-cn-error">{error}</div>}
    </form>
  );
}
